export const STATUS = {
  in_progress: {
    color: '#1976D2',
    bgcolor: '#E3F2FD'
  },
  closed: {
    color: '#587F31',
    bgcolor: '#E6F0D7'
  },
  production: {
    color: '#587F31',
    bgcolor: '#E6F0D7'
  },
  abandoned: {
    color: '#DC2626',
    bgcolor: '#FEE2E2'
  },
  vsr: {
    color: '#587F31',
    bgcolor: '#E6F0D7'
  },
  standby: {
    color: '#D97706',
    bgcolor: '#FEF3C7',
  }
}

export const FILTER_PROJECTS_STATUS = ['in_progress', 'closed', 'abandoned', 'standby']

export const CATEGORIES_PROJECT = {
  legacy_project: {
    icon: 'clipboard-list-check'
  },
  lan: {
    icon: 'network-wired',
  },
  collect: {
    icon: 'at'
  },
  voip: {
    icon: 'phone'
  },
  tv_and_chromecast: {
    icon: 'screencast'
  },
  lan_service: {
    icon: 'badge-check'
  },
  wibox_and_security: {
    icon: 'shield'
  },
  cctv: {
    icon: 'camera-cctv'
  }
}

export const STEP_ORDER = ['audit', 'technical_visit', 'construction', 'commissioning', 'acceptance'] as const

export const STEP_MAPPING: Record<string, string> = {
  'audit': 'audit',
  'technical_visit': 'technical_visit',
  'construction': 'construction',
  'procube_commissioning_process': 'commissioning',
  'acceptance': 'acceptance'
}

export const STEPS_WITHOUT_TOOLTIP = ['commissioning', 'acceptance']

export const STATUS_CONFIG = {
  completed: {
    ...STATUS.production,
    labelKey: 'projects.process.status.tooltip.completed'
  },
  scheduled_soon: {
    ...STATUS.standby,
    labelKey: 'projects.process.status.tooltip.scheduled_soon'
  },
  in_progress: {
    ...STATUS.in_progress,
    labelKey: 'projects.process.status.tooltip.in_progress'
  },
  upcoming: {
    color: '#5D5D5D',
    bgcolor: '#E7E7E7',
    labelKey: 'projects.process.status.upcoming'
  }
} as const
